import React from "react";
import Section from "../components/Section";
import Reading from "../components/Reading";
import { Link } from "react-router-dom";

function Readings() {
  return (
    <div className="page-container">
      {/* Header Image */}
      <img
        src="./readings/Readings_header.png"
        alt="Readings"
        className="header-img"
      />

      {/* WEEK 1 */}
      <h1 className="section-header">Week 1</h1>
      <Section
        content={
          <div>
            <Reading
              header="Weaving Fire into Form: Ch. 1 - up to p.48 [UG & G]"
              link="https://drive.google.com/file/d/1szJgyZry5tn9-JixW4N86g6ZsiigyBIO/view?usp=sharing"
              content="The study of Tangible and Embodied Interaction (TEI) spans philosophy, psychology, 
              and theory; computing; electrical and mechanical engineering; making, design, art, culture; and well 
              beyond. The creators of tangible interfaces include book binders, circuit benders, glass blowers, 
              performing artists, weavers of code and fibers, and observers of humans in past, present, and 
              future modes of engaging each other and our world."
            />
            <Reading
              header="Weaving Fire into Form: Ch. 3 - sections 3.1 & 3.3 [UG & G]"
              link="https://drive.google.com/file/d/1DYcgtOXuPL2GxQ5Uk_cIYi9DBptsxC3_/view?usp=sharing"
              content="The first two chapters provided a broad overview of tangible and embodied interaction, 
              laying the groundwork for a deeper investigation of four key facets: concept, cognition, design and technology, 
              and aspirations. This chapter examines the evolving concept of tangible and embodied interaction (TEI)."
            />
            <Reading
              header="Weaving Fire into Form: Ch. 4 - section 4.4 [UG], whole chapter [G]"
              link="https://drive.google.com/file/d/1CXwLUKFjhSEYFM2Xh6xYJ41Zjg28x3W7/view?usp=sharing"
              content="In this chapter we delve into the cognition facet that influenced and informed the 
              concept of tangible and embodied interaction. In particular, we focus on the notions of cognition that 
              recognize that we are physical beings, and that our existence is grounded in the physical world and is 
              processed through our sensory and motor interactions with the space around us and with the things and 
              people that exist within it."
            />
            <Reading
              header="
              Tangible Bits: Towards Seamless Interfaces between People, Bits and Atoms [UG & G]"
              link="https://drive.google.com/file/d/1Weml8pX8t8gaxJ0fjlru0F6i6Po4LJW6/view?usp=sharing"
              content="This paper presents our vision of Human Computer Interaction (HCI): “Tangible Bits.” 
              Tangible Bits allows users to “grasp & manipulate” bits in the center of users’ attention by 
              coupling the bits with everyday physical objects and architectural surfaces."
            />
            <Reading
              header="The Role of Physicality in Tangible and Embodied Interactions [G]"
              link="https://drive.google.com/file/d/1SxTE38KWS77Wkk37XysIge5it6GnsnbH/view?usp=sharing"
              content="This forum aims to provide a glimpse of the discussions and approaches in TEI, reflecting 
              the diversity of the field and the field’s interest in the role of physicality in interaction."
            />
          </div>
        }
      />

      {/* WEEK 2 */}
      <h1 className="section-header">Week 2</h1>
      <Section
        content={
          <>
            <Reading
              header="Weaving Fire into Form: Ch. 5 [UG & G]"
              link="https://drive.google.com/file/d/1LUOj5e0Z5NYxMHxmBLJ4-tT6Aea7UX9E/view?usp=sharing"
              content="Most TEI systems are fundamentally entangled with physical artifacts. Where we have 
              discussed many grounding examples and theories, the question of how tangibles are designed, fabricated, 
              and brought to life is deeply central. Each of these topics is independently worthy of dedicated book(s). 
              Here, we seek to provide a high-level overview, focused largely on mediating technologies, with some 
              high-level consideration of design and fabrication."
            />
            <Reading
              header="Weaving Fire into Form: Ch. 6 [UG & G]"
              link="https://drive.google.com/file/d/1TnkfXHfCQsxNeu3k60f_jhqyp5hF_2QH/view?usp=sharing"
              content="This chapter focuses on designing tangible and embodied interaction. How to create 
              meaningful interactions, and how to ride the notion of tangibility and embodiment 
              (or animacy after Ingold [2013]), and how to play with the richness and subtleties of 
              materials and dynamics to fit the skills and modalities of a person?"
            />
            <Reading
              header="
              How Bodies Matter: Five Themes for Interaction Design [UG & G]"
              link="https://drive.google.com/file/d/1vxIseojZYXOju_sZyKBbmMt-8_lUnabP/view?usp=sharing"
              content="Our physical bodies play a central role in shaping human experience in the world, 
              understanding of the world, and interactions in the world. This paper draws on theories of embodiment — 
              from psychology, sociology, and philosophy — synthesizing five themes we believe are particularly
              salient for interaction design: thinking through doing, performance, visibility, risk, and thick practice. We 
              introduce aspects of human embodied engagement in the world with the goal of inspiring new interaction design 
              approaches and evaluations that better integrate the physical and computational worlds."
            />

            <Reading
              header="
              Exploring Relationships Between Interaction Attributes and Experience [G]"
              link="https://drive.google.com/file/d/1Sz44PEVg1bpYAqWUSKIo0cBwBJGEMGRP/view?usp=sharing"
              content="Not long ago, interaction was predominantly determined by technology itself or adhered to simple 
              principles of efficiency (e.g., only three clicks away). Today interaction has to 'feel good' and has to 
              be 'beautiful'. This poses the question of how to conceptualize this emerging 'aesthetics of interaction'. 
              In the present paper, we discuss existing approaches and present an own perspective. In our approach, the 
              conscious differentiation between interaction attributes (e.g., slow, mediated, delayed) and the emerging
              experience (e.g., experiencing a positive and meaningful moment) is a crucial, conceptual step."
            />
          </>
        }
      />

      {/* Project-specific readings */}
      <h1 className="section-header">Project Specific Readings</h1>
      <Section
        content={<p className="section-text">For project specific readings, navigate to the&nbsp; 
        <Link to="/projects">project page</Link>.</p>}
      />
    </div>
  );
}

export default Readings;
